import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";

import type { CommonInfo } from "@repo/ui/types";

import { useAppSelector } from "@repo/store/hooks";

export interface CmsState {
  sharedContent: CommonInfo | null;
}

const initialState: CmsState = {
  sharedContent: null,
};

const cmsSlice = createSlice({
  name: "cms",
  initialState,
  reducers: {
    setSharedContent: (state, action: PayloadAction<CommonInfo>) => {
      state.sharedContent = action.payload;
    },
  },
});

export const useSharedContent = () => useAppSelector((state) => state.cms.sharedContent);

export const { setSharedContent } = cmsSlice.actions;

export default cmsSlice.reducer;
